import React from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';

function CircleVisibility({ title, checked, disabled, onChange }) {
  return (
    <label className='circle-check circle-visibility'>
      <Switch
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        aria-label={`Is public: ${title}`}
        checkedIcon={false}
        uncheckedIcon={false}
        onColor='#222222'
        height={20}
        width={36}
      />
      Is public
    </label>
  );
}

CircleVisibility.propTypes = {
  title: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

export default CircleVisibility;
